<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="themeObjectValues"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';
import { generateClass, getClassDefinition } from '@/utils/tailwind-helper';

export default {
    name: 'calendar-facet-day-font-size',
    mixins: [baseOption],

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            displayName: 'Font Size',
            tailwindDefinitionProp: 'fontSize',
        };
    },

    methods: {
        onInput(sizeIndex) {
            let cssClass = '';
            if (sizeIndex) {
                const size = this.themeObjectValues[sizeIndex];
                cssClass = generateClass({
                    screen: this.screen,
                    tailwindDefinitionProp: this.tailwindDefinitionProp,
                    value: size,
                });
            }

            this.onOptionChange(cssClass);
            this.$emit('input', cssClass);
        },

        onSelectedElement() {
            if (this.value) {
                const classDefinition = getClassDefinition(this.value);
                if (classDefinition) {
                    this.sliderIndex = this.themeObjectValues.findIndex(i => i === classDefinition.value);
                }
            }
        },
    },
};
</script>
